import React, { Component, PropTypes } from 'react'

export class BiColumn extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__body">
            <div className="row">
              <div className="column--third">
                <div className="section__head--leftAlign">
                  <h5>PlayVS is headquartered in Santa Monica, CA and is rapidly expanding.  </h5>
                </div>
              </div>
              <div className="column--twoThird">
                <div className="section__head--leftAlign noMaxWidth">
                  <p className="lead">
                    We work with game publishers and high school governing bodies to build and operate sanctioned leagues across the country.  The challenges we solve on a daily basis are exciting and relevant.  We’re looking for top talent to help us create the world’s first full-stack sports platform.{' '}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default BiColumn



// WEBPACK FOOTER //
// ./src/common/ui/components/biColumn__careers.js